import { render } from "./IntermezzoComp.vue?vue&type=template&id=288b3dcf"
import script from "./IntermezzoComp.vue?vue&type=script&lang=js"
export * from "./IntermezzoComp.vue?vue&type=script&lang=js"

import "./IntermezzoComp.vue?vue&type=style&index=0&id=288b3dcf&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\compro.rimba.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__